export default __webpack_public_path__ + "static/media/bipolar_mobile.b35ebdab.png";